import { PARAMS_REQUEST_DETAIL } from './create-request';
import { JOB_SURCHARGE_STATUS } from './job';

/* =========== ENUM ============ */
export enum CARD_TYPE {
  VISA = 'visa',
  MASTER_CARD = 'master-card',
  USA_EXPRESS = 'america-express',
}

export enum PAYMENT_METHOD {
  PAY_NOW = 'paynow',
  CARD = 'card',
  ADD_NEW_CARD = 'ADD_NEW_CARD',
}

export enum PAYMENT_STATUS {
  SUCCESS = 'success',
  PENDING = 'pending',
  FAILED = 'failed',
  CANCELLED = 'cancelled',
  NULL = '',
}

export enum PAYMENT_TYPE {
  SEARCH_FEE = 'search-fee',
  TRIAL_JOB = 'trial-job',
  AC_JOB_NOT_ENOUGH_BALANCE = 'ac-job-not-enough-balance',
  AC_JOB_ENOUGH_BALANCE = 'ac-job-enough-balance',
  PURCHASE_PACKAGE = 'purchase-package',
}

export enum SURCHARGE_TITLE {
  ADDITIONAL_CHILD = 'Additional Child Surcharge',
  WEEKEND_SURCHARGE = 'Weekend Surcharge',
  ODD_HOURS_SURCHARGE = 'Odd Hours Surcharge',
  PAYMENT_GATE_WAY_FEE = 'Payment Gateway Fee',
  PUBLIC_HOLIDAY = 'Public Holiday Surcharge',
}

/* =========== INTERFACE ============ */
export interface CREDIT_BALANCE_RESPONSE {
  parent_id: string;
  balance: number;
  is_trial: boolean;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
}

export interface CARD_LIST_RESPONSE {
  id: string;
  last4: string;
  brand: CARD_TYPE;
}

export interface SEARCH_FEE_PAYLOAD extends PARAMS_REQUEST_DETAIL {
  payment_method_id?: string; // for card + stripe
  payment_method_type: PAYMENT_METHOD;
  // transaction_type: 'AC Search Fee';
}

export interface CHECKOUT_SEARCH_FEE_PAYLOAD {
  payment_method_type: PAYMENT_METHOD;
}

export interface PURCHASE_PACKAGE_PAYLOAD {
  payment_method_id?: string; // for card + stripe
  payment_method_type: PAYMENT_METHOD;
  package_id: string;
}

export interface PAY_JOB_PAYLOAD {
  payment_method_id?: string; // for card + stripe
  payment_method_type?: PAYMENT_METHOD;
  job_id: string;
}

export interface AC_JOB_PAYLOAD {
  job_id: string;
}

export interface PAYMENT_RESPONSE {
  id: string;
  amount: number;
  currency: string;
  status: string;
  client_secret: string;
  next_action: {
    paynow_display_qr_code: PAY_NOW_QRCODE;
    type: string;
  };
}

export interface PAY_NOW_QRCODE {
  data: string;
  hosted_instructions_url: string;
  image_url_png: string;
  image_url_svg: string;
}

export interface ATTACH_PAYMENT_METHOD_PAYLOAD {
  payment_method_id: string;
}

export interface WEB_HOOK_PAYMENT_RESPONSE {
  amount: string;
  parent_id: string;
  payment_intent_id: string;
}

export interface CHECKOUT_PAYMENT_RESPONSE {
  amount: number;
  tax_amount: number;
  total_amount: number;
  balance: number;
  offset?: number; // total amount parent need to pay(only trial job)
  offset_amount?: number; // total amount parent need to pay(only trial job)
  is_can_purchase_package: boolean;
  payment_gateway_fee?: PAYMENT_GATE_WAY_FEE_TYPE;
  adjustment_surcharges: SURCHARGE_ITEM_DATA[];
  additional_child_surcharge: {
    amount: number;
    child_count: number;
    percentage: number;
    title: SURCHARGE_TITLE;
  };
  odd_hour_surcharge: {
    amount: number;
    child_count: number;
    percentage: number;
    title: SURCHARGE_TITLE;
  };
  weekend_surcharge: {
    amount: number;
    child_count: number;
    percentage: number;
    title: SURCHARGE_TITLE;
  };
  public_holiday_surcharge: {
    title: SURCHARGE_TITLE;
    amount: number;
    hours: number;
    percentage: number;
  };
}

export interface SURCHARGE_ITEM_DATA {
  description: string;
  id: string;
  parent_rate: number;
  sitter_rate: number;
  status: JOB_SURCHARGE_STATUS;
}

export interface PAYMENT_GATE_WAY_FEE_TYPE {
  amount: number;
  percentage: number;
  title: string;
}

export interface CONFIG_SURCHARGE_RESPONSE {
  value: number;
  id: string;
  title: string;
  type: string;
  key: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}
